import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class ParceiroService {
    async update(data: any) {
        return await api.put<any>(`${resources.parceiro}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.parceiro}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getParceiros() {
        return await api.get<IGenericResult[]>(`${resources.parceiro}/GetAllParceiros`);
    }
}

export default new ParceiroService();
